export default __webpack_public_path__ + "static/media/Blue-Seashell-Diffuser-Stretch-Bracelet.2736ba45.jpg";